import { createAsyncThunk } from "@reduxjs/toolkit";
import { type EmailClient } from "@fitness-app/data-models/entities/ProductsSettings";
import { getError, getErrorMessage } from "@fitness-app/utils";

import { type ActionParams, type AsyncThunkCreator } from "../../../index";
import { PRODUCTS_SETTINGS_REDUCER_NAME } from "../types";

export type Payload = {
  url: string;
  client: EmailClient;
};

export const removeIntegrationWithEmailClient = createAsyncThunk<
  void,
  ActionParams<Payload>,
  AsyncThunkCreator<string>
>(
  `${PRODUCTS_SETTINGS_REDUCER_NAME}/removeIntegrationWithEmailClient`,
  async ({ onSuccess, onFailure, payload }, { rejectWithValue, extra: { integrationApi, analytics } }) => {
    try {
      await integrationApi.post("/remove-email-client-integration", payload);

      analytics.track("remove_integration_with_email_client", {
        client: payload.client,
      });
      onSuccess?.();
    } catch (e) {
      onFailure?.(getError(e).status);

      return rejectWithValue(getErrorMessage(e));
    }
  },
);
